<template>
	<div>
        <bga-layout-top-bar></bga-layout-top-bar>
        <div id="layoutSidenav">
            <!-- Side Bar -->
            <bga-layout-side-bar></bga-layout-side-bar>

            <div id="layoutSidenav_content">
                <!-- Content -->
                <main>
                    <slot></slot>
                </main>

                <!-- Footer -->
                <bga-layout-footer></bga-layout-footer>
            </div>
        </div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				links: [
                    '/adm',
                    '/clientes'
                ]
			}
		},
        created(){
            this.linkActive();
        },
        mounted(){
            document.body.classList.add('sb-nav-fixed');
        },
		methods: {
            linkActive(){
                var path = window.location.href; // because the 'href' 
                for(var i=0; i<this.links.length; i++){
                    if (this.links === path) {
                        $(this).addClass("active");

                    }
                }
            }
		}
	}
</script>

<style scoped>
    .mp-center {
        align-items: center;
    }
</style>